export default __webpack_public_path__ + "static/media/invoiceImage.2d8426ec.png";